import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/teacher-profile/[userId]/TeacherProfilePageClientNew.js");
